import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ParentFacadeService} from './parent-facade.service';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {ProfileType} from '@model/profile';

@Injectable()
export class ParentPreloadGuard  {
  constructor(private _parentFacade: ParentFacadeService, private _router: Router) {
  }

  canActivate(): Observable<boolean> {
    return this._parentFacade.profile$.pipe(
      map(profile => profile.type === ProfileType.PARENT),
      tap(allowed => {
        if (allowed) {
          this._parentFacade.loadChildren();
        } else {
          this._router.navigate(['/']);
        }
      })
    );
  }

}
